<template>
  <AppModal @close="$emit('close')">
    <div class="loading-modal">
      <div class="loading-modal__loader">
        <div class="loader"></div>
      </div>

      <div v-if="title || description" class="loading-modal__text">
        <p v-if="title" class="loading-modal__title">{{ title }}</p>
        <p v-if="description">{{ description }}</p>
      </div>
    </div>
  </AppModal>
</template>

<script>
import AppModal from './AppModal.vue'

export default {
  name: 'LoadingModal',
  components: { AppModal },
  emits: ['close'],
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    description: {
      type: String,
      required: false,
      default: '',
    },
    actions: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common-imports.scss';

.loading-modal {
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;

  &__loader {
    display: flex;
    align-items: center;
    justify-content: center;

    .loader {
      width: 60px;
      height: 60px;
      border: 5px solid rgba(29, 159, 58, 0.15);
      border-bottom-color: $GreenM;
      border-radius: 50%;
      display: inline-block;
      box-sizing: border-box;
      animation: rotation 1s linear infinite;

      @keyframes rotation {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    }
  }

  &__text {
    text-align: center;
  }

  &__title {
    font-weight: 500;
    font-size: 20px;
  }

  &__desc {
    margin-top: 16px;
  }
}
</style>
